export default {
  en: {
    title: "Locations"
  },
  it: {
    title: "Luoghi"
  }
};
